import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const TestLoginPage = () => {
  const { college, token, isAuthenticated, collegeId } = useAuth();

  const simulateLogin = () => {
    const mockCollegeData = {
      _id: '69037e0baa6f66166baefa1f',
      id: '69037e0baa6f66166baefa1f',
      name: 'Test College',
      email: 'admin@testcollege.edu',
      role: 'CollegeAdmin'
    };

    const mockToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb2xsZWdlSWQiOiI2OTAzN2UwYmFhNmY2NjE2NmJhZWZhMWYiLCJyb2xlIjoiQ29sbGVnZUFkbWluIiwiaWF0IjoxNzYxODM2NjA5LCJleHAiOjE3NjI0NDE0MDl9.DeuJPfA27e0ZXW7OGe8tf9IDBQ8A6TlMeVmIK8r3--s';

    console.log('🧪 Test: Setting localStorage manually...');
    localStorage.setItem('college_token', mockToken);
    localStorage.setItem('college_data', JSON.stringify(mockCollegeData));
    localStorage.setItem('college_id', mockCollegeData._id);

    console.log('🧪 Test: Reloading page to trigger auth initialization...');
    window.location.reload();
  };

  const clearLogin = () => {
    console.log('🧪 Test: Clearing localStorage...');
    localStorage.removeItem('college_token');
    localStorage.removeItem('college_data');
    localStorage.removeItem('college_id');
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-8">
      <div className="max-w-md w-full bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-bold mb-4">Test Authentication</h2>

        <div className="space-y-4">
          <div>
            <h3 className="font-semibold">Current Auth State:</h3>
            <p>Authenticated: <span className={isAuthenticated ? 'text-green-600' : 'text-red-600'}>{isAuthenticated ? 'Yes' : 'No'}</span></p>
            <p>College ID: <span className="font-mono">{collegeId || 'None'}</span></p>
            <p>College Name: {college?.name || 'None'}</p>
            <p>Has Token: <span className={token ? 'text-green-600' : 'text-red-600'}>{token ? 'Yes' : 'No'}</span></p>
          </div>

          <div className="space-y-2">
            <button
              onClick={simulateLogin}
              className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Simulate Login (Set localStorage)
            </button>

            <button
              onClick={clearLogin}
              className="w-full bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Clear Login (Clear localStorage)
            </button>

            <button
              onClick={() => window.location.href = '/login'}
              className="w-full bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
            >
              Go to Login Page
            </button>

            <button
              onClick={() => window.location.href = '/dashboard'}
              className="w-full bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Go to Dashboard
            </button>
          </div>

          <div className="mt-6 p-4 bg-gray-100 rounded text-sm">
            <h4 className="font-semibold mb-2">Test Credentials:</h4>
            <p>Email: admin@testcollege.edu</p>
            <p>Password: password123</p>
            <p>College ID: 69037e0baa6f66166baefa1f</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestLoginPage;